/**
 * Where a legend or one of its versions stands.
 *
 * - `Draft`: not published yet.
 * - `Published`: the version new jobs use.
 * - `Previous`: an older published version.
 * - `Inactive`: the legend can't be used for new jobs.
 */
export type LegendStatus = 'Draft' | 'Published' | 'Previous' | 'Inactive'

/**
 * The status of a legend, judging by its latest version.
 *
 * @param inactive
 * @param latestVersion
 */
export function getLegendStatus(
  inactive: boolean,
  latestVersion: { version: number; published: boolean },
): LegendStatus {
  if (inactive) {
    return 'Inactive'
  }
  return latestVersion.published || hasUnpublishedChanges(latestVersion)
    ? 'Published'
    : 'Draft'
}

/**
 * Whether the latest version is a draft on top of a published version.
 *
 * @param latestVersion
 */
export function hasUnpublishedChanges(latestVersion: {
  version: number
  published: boolean
}) {
  return latestVersion.version > 1 && !latestVersion.published
}
